import { url } from '@tencent/wphk-base-utils';
import { CHANNEL_PAGE_URL } from '@/config/index';
import { windowHelper } from '@tencent/ppd-base-libs';

/** 点击商户弹窗-商户标题打开Channel页adtag */
const JUMP_MRCH_ADTAG = 'mrch';
/** 点击优惠券弹窗-商户标题打开Channel页adtag */
const JUMP_CP_ADTAG = 'coupon';


/** 点击链接类型 */
export enum JumpType {
  'mrch' = 'mrch',
  'coupon' = 'coupon'
}

const JUMP_CONFIG: Record<JumpType, {adtag: string, link: string}> = {
  mrch: { adtag: JUMP_MRCH_ADTAG, link: CHANNEL_PAGE_URL },
  coupon: { adtag: JUMP_CP_ADTAG, link: CHANNEL_PAGE_URL },
};

/** 点击跳转Channel页 */
export const jumpChannelPage = ({ spId, type }: {spId: string, type: JumpType}) => {
  const { adtag, link } = JUMP_CONFIG[type];
  const targetUrl =  url.addUrlParams(link,  {
    ADTAG: adtag,
    spId,
  });
  windowHelper.redirect(targetUrl, 300);
};
